<template>
    <div class="portal">
        <div class="sub-header container-fluid">
            <div class="title"></div>
            <div class="tools">
                <div class="search-container">
                    <md-input-container>
                        <md-icon>search</md-icon>
                        <md-input type="text" v-model="searchText"></md-input>
                    </md-input-container>
                </div>
                <md-icon :class="{'active': showSidebar}" @click.native="showSidebar = !showSidebar">category</md-icon>
            </div>
        </div>
        <div class="portal-apps-container">
            <div class="portal-apps" :class="{'sidebarShown': showSidebar}">
                <div ontouchstart="this.classList.toggle('hover');"
                     v-if="groupedApps && hasCategory(app.Category) && app.Category !== 'Admin'"
                     v-for="(app, index) in filteredApps"
                     :key="index"
                     class="portal-app flip-container"
                >
                    <div class="flipper">
                        <div class="front">
                            <div class="portal-app">
                                <div class="portal-app__image">
                                    <img :src="getImageSrc(app.image)" alt="">
                                    <div class="portal-app__image-placeholder">WB</div>
                                </div>
                                <div class="portal-app__name">{{app.Name}}</div>
                            </div>
                        </div>
                        <div class="back">
                            <div class="portal-app">
                                <div class="portal-app__envs" v-if="app.apps">
                                    <div class="app__env" :class="{disabled: !isEnvActive('Develop', app.apps)}"
                                         @click="forward(getAppByEnv('Develop', app.apps))">
                                        <img src="../uiassets/icons/icon-dev.svg" alt="">
                                        <br>
                                        Dev
                                    </div>
                                    <div class="app__env" :class="{disabled: !isEnvActive('Test', app.apps)}"
                                         @click="forward(getAppByEnv('Test', app.apps))">
                                        <img src="../uiassets/icons/icon-test.svg" alt="">
                                        <br>
                                        Test
                                    </div>
                                    <div class="app__env" :class="{disabled: !isEnvActive('Acceptance', app.apps)}"
                                         @click="forward(getAppByEnv('Acceptance', app.apps))">
                                        <img src="../uiassets/icons/icon-acceptance.svg" alt="">
                                        <br>
                                        Acc
                                    </div>
                                    <div class="app__env" :class="{disabled: !isEnvActive('Production', app.apps)}"
                                         @click="forward(getAppByEnv('Production', app.apps))">
                                        <img src="../uiassets/icons/icon-live.svg" alt="">
                                        <br>
                                        Live
                                    </div>
                                </div>
                                <div class="portal-app__no-envs" v-else @click="forward(app)">
                                    <img src="../uiassets/icons/icon-open-app.svg" alt="">
                                    <br>
                                    Open app
                                </div>
                                <div class="portal-app__name">{{app.Name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transition
                    name="slide-left"
                    enter-active-class="slideAppear"
                    leave-active-class="slideDisappear">
                <div class="portal-apps-sidebar" v-if="showSidebar">
                    <div class="categories-title">
                        Categories
                        <md-icon class="close-categories" @click.native="showSidebar = false">close</md-icon>
                    </div>
                    <div class="category" v-for="(cat, index) in categories">
                        <div class="md-checkbox md-theme-default" :class="{'md-checked': localSelectedCategories.includes(cat)}" :value="cat">
                            <div tabindex="0" class="md-checkbox-container">
                                <input type="checkbox" tabindex="-1" :id="`${cat}-${index}`" :value="cat" v-model="localSelectedCategories">
                            </div>
                            <label class="md-checkbox-label" :for="`${cat}-${index}`">{{cat}}</label>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import managedata from '../helpers/managedata';
    import config from '../helpers/config';
    import {mapGetters} from 'vuex';

    export default {
        name: 'Portal',
        computed: {
            ...mapGetters([
                'groupedApps',
                'selectedCategories',
                'categories',
                'assignments',
                'WBToken',
                'userId'
            ]),
            filteredApps() {
                return this.searchText ? this.sortedApps.filter(el => el.Name.toLowerCase().includes(this.searchText.toLowerCase())) : this.sortedApps;
            },
            sortedApps() {
                return this.groupedApps && this.groupedApps.slice().sort((a, b) => {
                    const catA = a.Name && a.Name.toUpperCase();
                    const catB = b.Name && b.Name.toUpperCase();

                    if (catA < catB) {
                        return -1;
                    }
                    if (catA > catB) {
                        return 1;
                    }
                    return 0;
                })
            }
        },
        data() {
            return {
                localSelectedCategories: null,
                showSidebar: false,
                searchText: '',
            }
        },
        methods: {
            hasCategory(category) {
                return this.localSelectedCategories && this.localSelectedCategories.findIndex(cat => cat === category) !== -1;
            },
            enabled(app) {
                return this.assignments && app && this.assignments.findIndex(assignment => assignment.appId == app.id) !== -1;
            },
            forward(app) {
                if (this.enabled(app)) {
                    const url = app.url;
                    const token = this.WBToken || localStorage.getItem('WBToken');
                    const userId = this.userId || localStorage.getItem('userId');
                    window.location.href = url + "?wbtoken=" + token + '&user=' + userId;
                }
            },
            getImageSrc(src) {
                let result = '';
                if (src && src.indexOf('http') !== -1) {
                    result = src;
                } else {
                    result = '/static/' + src;
                }
                return result;
            },
            isEnvActive(env, apps) {
                return !!apps.find(e => e.environment === env);
            },
            getAppByEnv(env, apps) {
                return apps.find(e => e.environment === env);
            }
        },
        mounted() {
            this.$store.dispatch('getGroupedApps')
                .then(() => {
                    const userApps = this.groupedApps.filter(app => app.id !== config.appId);
                    // if (userApps.length > 1 || (userApps.length === 1 && userApps[0].url === null)) {
                    //     return this.$store.dispatch('getAssignments');
                    // }
                    if (userApps.length > 0 || (userApps.length === 1 && userApps[0].url === null)) {
                        return this.$store.dispatch('getAssignments');
                    }
                    /*else if(userApps.length === 1 && !this.$store.state.isAdmin) {
                             window.location.href = userApps[0].url;
                           }*/
                })
                .then(() => {
                    this.localSelectedCategories = this.selectedCategories;
                })
        }
    }
</script>

<style scoped>
    /*.sidebarShown {
        width: calc(100% - 250px) !important;
    }*/

    .close-categories {
        position: absolute;
        right: 9px;
        top: -4px;
        cursor: pointer;
    }

    .portal-apps-container {
        display: flex;
    }
    
    .categories-title {
        text-transform: uppercase;
        color: #9a9a9a;
        font-size: 15px;
        margin-top: 20px;
        position: relative;
    }

    .portal {
        background-color: #f7f7f9;
        min-height: 100vh;
    }

    .portal-app.flip-container {
        padding: 0;
        border: none;
        box-shadow: none;
    }

    .portal-filter {
        width: 400px;
        margin: 20px auto;
    }

    .portal-apps {
        display: grid;
        grid-template-columns: repeat(auto-fit, 200px);
        grid-gap: 20px;
        padding: 20px;
        width: 100%;
        overflow-y: scroll;
        max-height: calc(100vh - 140px);
    }

    .portal-apps-sidebar {
        width: 250px;
        min-height: calc(100vh - 140px);
        max-height: calc(100vh - 140px);
        background-color: #fff;
        padding: 15px;
    }

    .portal-apps-sidebar .md-checkbox {
        margin: 8px 8px 8px 0;
    }

    .portal-apps-sidebar .md-checkbox-container input {
        cursor: pointer;
    }

    .portal-app__envs {
        display: grid;
        grid-template-columns: repeat(auto-fit, 50%);
        text-align: center;
        border-bottom: 1px solid #f590be;
        padding: 10px;
    }

    .portal-app__no-envs {
        height: 196px;
        border-bottom: 1px solid #f590be;
        cursor: pointer;
        text-align: center;
        padding-top: 45px;
    }

    .portal-app__no-envs img {
        transition: .3s;
    }
    .portal-app__no-envs:hover img {
        transform: scale(1.2);
    }

    .app__env {
        padding: 11px;
        cursor: pointer;
        text-transform: uppercase;
    }

    .app__env:hover img {
        transform: scale(1.2);
    }

    .app__env.disabled {
        opacity: 0.5;
        cursor: default;
    }

    .app__env.disabled:hover img {
        transform: scale(1);
    }

    .app__env:first-child {
        border-bottom: 1px dashed #f590be;
        border-right: 1px dashed #f590be;
    }

    .app__env:nth-child(2) {
        border-bottom: 1px dashed #f590be;
    }

    .app__env:nth-child(3) {
        border-right: 1px dashed #f590be;
    }

    .portal-app__envs img {
        width: 45px;
        transition: .3s;
    }

    .portal-app {
        height: 270px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        border: 2px solid transparent;
        cursor: pointer;
        padding: 10px;
        user-select: none;
    }

    .portal-app__image {
        width: 170px;
        height: 170px;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 auto;
        position: relative;
    }

    .portal-app__image-placeholder {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #e3217c;
        color: #fff;
        text-shadow: 1px 3px 1px rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3rem;
    }

    .portal-app__image img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
        border-radius: 50%;
    }

    .portal-app__name {
        text-align: center;
        margin-top: 20px;
    }

    .back .portal-app__name {
        -moz-transform: scale(-1, 1);
        -webkit-transform: scale(-1, 1);
        -o-transform: scale(-1, 1);
        -ms-transform: scale(-1, 1);
        transform: scale(-1, 1);
    }

    .disabled {
        opacity: .6;
        cursor: not-allowed;
    }

    .flip-container {
        perspective: 1000px;
    }

    .flip-container:hover .flipper, .flip-container.hover .flipper {
        transform: rotateY(180deg);
    }

    /*    .flip-container, .front, .back {
            width: 320px;
            height: 480px;
        }*/

    .flipper {
        transition: 0.6s;
        transform-style: preserve-3d;
        position: relative;
    }

    .front, .back {
        backface-visibility: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    .front {
        z-index: 2;
        transform: rotateY(0deg);
        background-color: #fff;
    }

    .back {
        transform: rotateY(180deg);
        background-color: #EA227D;
        color: #fff;
    }

    .back .portal-app {
        padding: 0;
        cursor: default;
    }

    .sub-header {
        display: flex;
        height: 60px;
        padding-left: 30px;
        padding-right: 30px;
        border-bottom: 1px solid #d4d4d4;
        color: #606060;
        background: #fff;
        justify-content: space-between;
    }

    .sub-header:after {
        display: none;
    }

    .sub-header .title {
        line-height: 60px;
        height: 60px;
        display: flex;
        margin: 0 15px 0 0;
        color: #666;
        font-weight: 400;
        font-size: 18px;
    }

    .sub-header .title .material-icons {
        font-size: 16px;
        line-height: 60px;
        height: 60px;
        margin: 0 4px;
        display: inline-block;
    }

    .sub-header .tools {
        display: inline-block;
        height: 100%;
        float: right;
    }

    .sub-header .tools i {
        display: inline-block;
    }

    .sub-header .tools > i {
        height: 40px;
        width: 40px;
        line-height: 40px;
        text-align: center;
        color: #4A90E2;
        cursor: pointer;
    }

    .sub-header .tools > i.active {
        background: #4A90E2;
        color: #fff;
    }

    .slideAppear {
        animation: slideLeft 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    .slideDisappear {
        animation: slideRight 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    @keyframes slideLeft {
        0% {
            max-width: 0px;
            overflow: hidden;
        }
        100% {
            max-width: 250px;
            overflow: auto;
        }
    }

    @keyframes slideRight {
        0% {
            max-width: 100%;
            overflow: auto;
        }
        100% {
            max-width: 0px;
            overflow: hidden;
        }
    }

    .md-checkbox .md-checkbox-container input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        margin: 0;
        opacity: 0;
        z-index: 999;
    }

    .sub-header .search-container{
        width: 200px;
        margin-right: 20px;
        display: inline-block;
        height: 100%;
    }
    .sub-header .tools .search-container i{
        position: absolute;
        top: 14px;
    }
    .sub-header .search-container .md-input-container{
        margin: 0;
        padding: 0;
        height: 100%;
    }
    .sub-header .search-container .md-input-container input{
        height: 53px;
        margin: 0;
        padding-left: 36px;
        padding-top: 16px;
    }
    .sub-header .search-container .md-input-container:after{
        height: 2px;
        background-color: rgba(0,0,0,.4);
        bottom: 10px;
    }
    .sub-header .search-container .md-input-container.md-input-focused:after{
        background-color: #4A90E2;
    }
</style>



// WEBPACK FOOTER //
// Portal.vue?4050773a